import React, { useMemo } from "react";
import Select from "react-select";
import { useQuery } from "@tanstack/react-query";
import { fetchMultipleObservation } from "services/dropdown";
import { DROPDOWN_STALE_TIME } from "utils/constants";
import { Controller } from "react-hook-form";

const ObservationDropdownMultiSelector = ({
  errors,
  control,
  setValue,
  watch,
  mappedData,
}) => {
  const selectedObservation = watch("observation_id");

  const {
    data: Observations,
    isLoading,
    error,
  } = useQuery(["ObservationDropdown"], fetchMultipleObservation, {
    keepPreviousData: false,
    staleTime: DROPDOWN_STALE_TIME,
  });

  const optionsList = useMemo(
    () =>
      Observations?.data?.data?.map((data) => ({
        value: data?.id,
        label: data?.observation,
      })) || [],
    [Observations]
  );

  const defaultOptions =
    mappedData
      ?.map((label) =>
        optionsList.find((opt) => opt?.label?.trim() === label?.trim())
      )
      ?.filter(Boolean) || [];

  const availableOptions = optionsList.filter(
    (opt) => !mappedData?.some((label) => label?.trim() === opt?.label?.trim())
  );

  const options = [...defaultOptions, ...availableOptions];

  if (isLoading) return <div>Loading...</div>;
  if (error) return <div>Error loading observations</div>;

  return (
    <Controller
      name="observation_id"
      control={control}
      rules={{ required: "Observation is required" }}
      render={({ field }) => (
        <Select
          {...field}
          options={options}
          isClearable
          isMulti
          placeholder="Select Observation Names"
          menuPortalTarget={document.body}
          value={options.filter(
            (option) =>
              selectedObservation?.includes(option?.value) ||
              defaultOptions?.some(
                (defaultOpt) => defaultOpt?.value === option?.value
              )
          )}
          onChange={(selectedOptions) => {
            const values =
              selectedOptions?.map((option) => option?.value) || [];
            const labels =
              selectedOptions?.map((option) => option?.label) || [];
            field.onChange(values);
            setValue("observation_id", values);
            setValue("observation_name", labels);
          }}
          className={`react-select-container ${
            errors?.observation_id ? "is-invalid" : ""
          }`}
          styles={{
            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
            control: (base) => ({
              ...base,
              minHeight: "42px",
              maxHeight: "auto",
              overflowY: "auto",
            }),
            valueContainer: (base) => ({
              ...base,
              maxHeight: "42px",
              overflowY: "auto",
            }),
            multiValue: (base) => ({
              ...base,
              maxWidth: "100%",
            }),
          }}
        />
      )}
    />
  );
};

export default ObservationDropdownMultiSelector;
